import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/rem';
  @import 'src/common/styling/_mixins-scss/screen-size';

  .SavedReportsTable {
    .ReactDataTable__wrapper {
      .ReactDataTable {
        tr {
          grid-template-columns:
            minmax(100px, 1fr) /* IB account */
            minmax(150px, 1fr) /* Date */
            minmax(120px, 1.5fr) /* Status */
            minmax(150px, 2fr) /* Report name */
            minmax(180px, 1.5fr) /* Period */
            minmax(70px, 0.7fr); /* Actions */
        }

        .ReactDataTable__tbody-cell {
          display: flex;
          align-items: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          span {
            font-size: rem(14px);
          }

          &:nth-child(1) {
            cursor: pointer;
          }

          &:nth-child(4) {
            font-weight: 500;
          }
        }
      }
    }

    /* --- Responsive layout --- */
    .ResponsiveTable__thead {
      min-width: 320px !important;
      display: flex;

      span {
        text-align: left;
        padding: 5px 0;

        &:nth-child(1) {
          flex: 2; /* IB account */
        }
        &:nth-child(2) {
          flex: 3; /* Status */
        }
        &:nth-child(3) {
          flex: 4; /* Report name */
        }
      }
    }

    .ResponsiveTable__row {
      .ResponsiveTable__preview-main {
        display: flex;
        align-items: center;
        gap: 8px;
        height: 44px;

        .ResponsiveTable__row-item {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &:nth-child(1) {
            flex: 2; /* IB account */
          }

          &:nth-child(2) {
            flex: 3; /* Status */
          }

          &:nth-child(3) {
            flex: 4; /* Report name */
            font-weight: 500;
          }
        }
      }

      .ResponsiveTable__preview-description {
        .ResponsiveTable__row-item {
          justify-content: flex-start;
          padding-left: 10%;
        }

        :global(.StatusCell) {
          font-size: rem(12px) !important;
        }
      }

      .ResponsiveTable__details-item {
        padding-left: 15%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .SavedReportsTable__ib-account:hover {
    color: #0aa1e2;
    transition: 0.4s;
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .SavedReportsTable__download-button {
      &:hover {
        svg {
          path {
            &:first-child {
              fill: ${colors.primary.hex};
            }

            &:nth-child(2) {
              stroke: ${colors.primary.hex};
            }
          }
        }
      }
      &:disabled {
        &:hover {
          :global(svg) {
            :global(path) {
              fill: ${colors.gray.hex};
            }
          }
        }
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
